import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import React, { useState } from "react";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import Apple from "../assets/icons/apple";
import GooglePlay from "../assets/icons/googleplay";
// import { DirectPaths } from "@/config/routes";
import GetICMAppModal from "./get-icm-app-modal";

function InvestJourney() {
    const backgroundImage = `url("${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/ICMLogoPattern.webp")`;
    const [showAppModal, setShowAppModal] = useState<boolean>(false);

    const toggleDownloadApp = () => {
        setShowAppModal(!showAppModal);
    };

    return (
        <div
            className="flex flex-col items-center justify-center gap-s13 bg-info-1000 bg-cover bg-y-pos-mobile bg-no-repeat py-s15 sm:py-s18 md:bg-y-pos-desktop"
            style={{
                backgroundImage,
            }}
        >
            <div className="w-2/4 text-center text-3xl font-semibold leading-[120%] tracking-[-1%] text-white md:text-6xl">
                Start your Unlisted Shares Investment Journey Today.
            </div>
            <div className="flex w-10/12 flex-col items-center justify-center gap-s7 sm:flex-row">
                <RegularButton
                    noIcon
                    label="Get Started"
                    showRightIcon={false}
                    variant={ButtonVariant.PrimaryDefault}
                    onClick={() => {
                        setAnalyticsEvent(
                            `${process.env.ICM_UE_POST_URL || ""}/login`,
                            "Get_Started_Fold8",
                        ); // Replace "get_started_event" with your actual event name
                        window.location.href = `${process.env.ICM_UE_POST_URL}/login`;
                    }}
                    size={ButtonSize.Large}
                    className="min-w-full max-w-[239px] flex-1 sm:min-w-fit"
                />
                {/* <RegularButton
                    noIcon
                    label="Download the app"
                    showRightIcon={false}
                    variant={ButtonVariant.SecondaryWhite}
                    onClick={() => (window.location.href = process.env.ICM_PLAYSTORE_URL || "")}
                    size={ButtonSize.Large}
                    className="min-w-full flex-1 sm:min-w-fit"
                /> */}
                <RegularButton
                    id="download-app-button"
                    noIcon
                    showRightIcon={true}
                    rightIcon={
                        <div className="flex h-12 min-w-16 items-center justify-center gap-s4">
                            <Apple className="h-10 w-10 text-black" />
                            <div className="h-full w-[3px] bg-neutralOpacityDark-20"></div>
                            <GooglePlay className="h-10 w-10 text-black" />
                            <div className="absolute -top-[14px] right-7 rounded-full border border-orange-500 bg-orange-100 px-4 py-1 text-xs">
                                Coming soon
                            </div>
                        </div>
                    }
                    size={ButtonSize.Large}
                    variant={ButtonVariant.SecondaryDefault}
                    label="Download the App"
                    className="relative mt-4 w-[280px] cursor-auto border-white bg-white sm:mt-0 md:w-auto"
                    onClick={() => {
                        // setAnalyticsEvent(`${DirectPaths.HOME}`, "Home_Explore_Broking_Fold2");
                        // toggleDownloadApp();
                    }}
                />
            </div>
            <GetICMAppModal open={showAppModal} onClose={toggleDownloadApp} />
        </div>
    );
}

export default InvestJourney;
